// extracted by mini-css-extract-plugin
module.exports = {"root":"ViewHome_root__1nCfz","content":"ViewHome_content__2dHvx","buttons":"ViewHome_buttons__2Sxfy","introImage":"ViewHome_introImage__3BcpC"};